import { useMemo, useState } from 'react';

import { RoundedTabs } from '@components';
import { TabPill } from 'types/tabs';

import MetaInstagramIntegration from './MetaInstagramIntegration';
import MetaLeadFormsIntegration from './MetaLeadFormsIntegration';

import {
  MetaIntegrationTabId,
  metaIntegrationTabs
} from '../../constants/leadSettings';

const MetaIntegration = () => {
  const visibleTabs = useMemo(
    () => metaIntegrationTabs.filter((tab) => tab.isVisible),
    []
  );
  const [selectedTab, setSelectedTab] = useState<TabPill>(visibleTabs[0]);

  return (
    <div className="flex flex-col">
      {visibleTabs.length > 1 && (
        <RoundedTabs
          tabs={visibleTabs}
          selectedTab={selectedTab}
          onTabSelect={setSelectedTab}
        />
      )}
      <div
        className={`w-full rounded-xl border border-cofeeGreyBlue200 bg-cofeeNeutral1 shadow-sm ${
          selectedTab.id === MetaIntegrationTabId.LEAD_FORMS &&
          visibleTabs.length > 1
            ? 'rounded-tl-none'
            : ''
        }`}
      >
        {selectedTab.id === MetaIntegrationTabId.LEAD_FORMS && (
          <MetaLeadFormsIntegration />
        )}
        {selectedTab.id === MetaIntegrationTabId.INSTAGRAM && (
          <MetaInstagramIntegration />
        )}
      </div>
    </div>
  );
};

export default MetaIntegration;
